import Image from 'next/image'
import { PrimaryButton } from '../components/PrimaryButton'
import { EmptyFunction } from '../utils/functions'
import offline from '../../public/assets/offline.webp'

export const OfflineIndicator = ({ title = 'No Internet Connection', onClick = EmptyFunction }) => {
  return (
    <div id="offline_container" className="flex h-full w-full flex-col items-center justify-center">
      <div
        id="offline_title"
        className="bg-opacity-80 font-noto-sans text-base font-medium leading-[21.11px] text-[#404040]"
      >
        {title}
      </div>
      <div id="offline_image" className="mt-[8px]">
        <Image src={offline} width={120} height={175} alt="offline indicatore" />
      </div>
      <div id="offline_retry" className="mt-[32px] flex">
        <PrimaryButton title={'Retry'} className="px-[63.42px] text-[#333436]" {...{ onClick }} />
      </div>
    </div>
  )
}
